import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { DataService } from '@app/core/services/data.service';
import { ConfigurationService } from '@app/core/shell/services/configuration.service';
import { catchError } from 'rxjs/internal/operators/catchError';
import { map } from 'rxjs/internal/operators/map';
import { of } from 'rxjs';
import { SignupTransformsService } from './signup-transforms.service';
import { Adb2cService } from '@app/blocks/adb2c/services/adb2c/adb2c.service';

@Injectable({
    providedIn: 'root'
})
export class SignupDataService {

    constructor(private logger: LoggerService,
        private adb2cService: Adb2cService,
        private dataService: DataService,
        private http: HttpClient,
        private configService: ConfigurationService,
        private signupTransformsService: SignupTransformsService,) {
        this.adb2cService.getUser();
    }

    getReferenceData() {
        return this.dataService.getReferenceData();
    }

    getPaymentMethod(applicationId: string) {
        this.logger.info('getPaymentMethod applicationId', applicationId);

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'ApplicationPaymentMethod/' + applicationId;

        return this.http.get(url).pipe(
            map((response: any) => {
                const model = response;
                model.applicationId = applicationId;
                return model;
            }),
            catchError((error: any) => {
                if (error.status === 404) { // not found
                    const model = error;
                    model.applicationId = applicationId;
                    this.logger.info("empty nextOfKinModel", model);
                    return model;
                } else {
                    this.logger.error('Application Payment Method error has occurred ', error);
                    return null;
                }
                return of(error);
            })
        )
    }

    getNextOfKin(applicationId: string) {
        this.logger.info('getNextOfKin applicationId', applicationId);

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'NextOfKin/' + applicationId;

        return this.http.get(url)
            .pipe(
                map((response: any) => {
                    const nextOfKinModel = response;
                    nextOfKinModel.applicationId = applicationId;
                    return nextOfKinModel;
                }),
                catchError((error: any) => {
                    if (error.status === 404) { // not found
                        const nextOfKinModel = error;
                        nextOfKinModel.applicationId = applicationId;
                        this.logger.info("empty nextOfKinModel", nextOfKinModel);
                        return nextOfKinModel;
                    } else {
                        this.logger.error('getNextOfKin an error has occurred ', error);
                        return null;
                    }
                })
            );
    }

    getAdditionalDetails(applicationId: string) {
        this.logger.info('getAdditionalDetails applicationId', applicationId);

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'additionalinformation/' + applicationId;

        return this.http.get(url)
            .pipe(
                map((response: any) => {
                    const additionalDetailsModel = response;
                    additionalDetailsModel.applicationId = applicationId;
                    return additionalDetailsModel;
                }),
                catchError((error: any) => {
                    if (error.status === 404) { // not found
                        const additionalDetailsModel = error.data;
                        additionalDetailsModel.applicationId = applicationId;
                        this.logger.info("empty additionalDetailsModel", additionalDetailsModel);
                        return additionalDetailsModel;
                    } else {
                        this.logger.error('getAdditionalDetails an error has occurred ', error);
                        return null;
                    }
                }));
    }

    postAdditionalDetails(formData: any) {
        const formBody = JSON.stringify(formData);
        this.logger.info('postAdditionalDetails', formBody);

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'additionalinformation/';

        return this.http.post(url, formBody, {
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        });
    }

    postEmergencyContacts(formData: any) {
        this.logger.info('postEmergencyContacts', JSON.stringify(formData));

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'emergencycontacts/' + formData.applicationId;

        return this.http.post(url, formData, {
            headers: { "Content-Type": "application/json; charset=UTF-8" }
        });
    }

    getEmergencyContacts(applicationId: string) {
        this.logger.info('getEmergencyContacts', applicationId);

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'emergencycontacts/' + applicationId;

        return this.http.get(url, {
            headers: { "Content-Type": "application/json; charset=UTF-8" }
        });
    }

    postNextOfKin(formData: any) {
        this.logger.info('postNextOfKin', JSON.stringify(formData));

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'NextOfKin/';

        return this.http.post(url, formData, {
            headers: { "Content-Type": "application/json; charset=UTF-8" }
        });
    }

    postPaymentMethod(formData: any) {
        this.logger.info('postPaymentMethod', JSON.stringify(formData));

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'ApplicationPaymentMethod/';

        return this.http.post(url, formData, {
            headers: { "Content-Type": "application/json; charset=UTF-8" }
        });
    }

    getApplicationStatus(applicationId: string, sub: string) {
        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'applicationstatus/' + sub + "/" + applicationId;
        this.logger.info('url', url);

        return this.http.get<any>(url);
    }
}
